import { PrivateRoute } from '@router/private-route';
import { RouteObject } from 'react-router-dom';

import { OverviewLayout } from '@modules/overview/overview.layout';
import { OverviewPage } from '@modules/overview/pages';
import { ROUTER } from '@core/constants/router.constants';

export const overviewRouter: RouteObject = {
  path: ROUTER.OVERVIEW.INDEX,
  Component: OverviewLayout,
  children: [{ index: true, element: <PrivateRoute element={<OverviewPage />} /> }],
};
